<template>
	<div>
		<v-list dense>
			<template v-for="(data, channel) in channels">
				<v-list-tile>
					<v-list-tile-content style="width: 20%">
						{{get_channel_title(channel)}}
					</v-list-tile-content>
					<v-list-tile-content style="width: 10%">
						{{get_source_state(data).state}}
					</v-list-tile-content>
					<v-list-tile-content style="width: 10%">
						{{get_port(data, "source")}}
					</v-list-tile-content>
					<v-list-tile-content style="width: 10%">
						{{get_port(data, "output")}}
					</v-list-tile-content>

					<v-list-tile-content style="width: 40%">
							<v-layout row>
							<template v-for="(info, ip) in get_dest_state(data)">
								<v-chip :color="get_color_for_state(info.status.state)" small style="font-size: 10px;">
									{{ip}}&nbsp;
								  	 <v-sparkline line-width="1" fill width="500" padding="8" color="white" :value="get_buffer_history(info.status)">
								  	 </v-sparkline>
								  	 <div>&nbsp;C:{{get_buffer_status(info.status)}}/M:{{get_max_history(info.status)}}</div>
								</v-chip>
							</template>
						</v-layout>
					</v-list-tile-content>
				</v-list-tile>
				<v-divider></v-divider>
			</template>
		</v-list>
	</div>
</template>

<script>

import ChannelModel from '@/models/channel.js';

export default {
	props: ["id"],
	methods: {
		get_channel(uuid) {
			return ChannelModel.channel_by_uuid(uuid);
		},
		get_channel_title(uuid) {
			var ch = this.get_channel(uuid);
			if (typeof(ch) != "undefined") return ch.title;
			return "";
		},
		get_buffer_status(data) {
			if (typeof(data != "undefined")) {
				if (typeof(data.info) != "undefined") {
					return data.info.buffer_status.current_length;
				}				
			}
			return "";
		},
		get_buffer_history(data) {
			if (typeof(data != "undefined")) {
				if (typeof(data.info) != "undefined") {
					if (typeof(data.info.buffer_status.history) != "undefined") {
						return _.map(data.info.buffer_status.history, (data) => {
							return data[1];
						});
					}
				}				
			}
			return [];
		},
		get_max_history(data) {
			var history = this.get_buffer_history(data);
			return _.max(history);	
		},
		get_state(data, type) {
			var i = data.instance;
			if (typeof(i) != "undefined") {
				var s = i[type];
				if (typeof(s) != "undefined") {
					return s;
				}
			}
			return;
		},
		get_color_for_state (state) {
      		if (state == "listening") return this.$dark() ? "orange darken-2" : "yellow darken-3";
      		if (state == "disconnected") return this.$dark() ? "red darken-3" : "red lighten-2";
      		if (state == "connecting") return this.$dark() ? "orange darken-4" : "orange";
      		if (state == "connected") return this.$dark() ? "green darken-3" : "green";
      		return undefined;
    	},

		get_source_state(data) {
			return this.get_state(data, "source");
		},
		get_dest_state(data) {
			return this.get_state(data, "destinations")
		},
		get_port(data, type) {
			var st = this.get_state(data, type)
			if (typeof(st) != "undefined") {
				var info = st.info;
				if (typeof(info) != "undefined") {
					return info.port;
				}
			}
			return;
		}
	},
	computed: {
		channels () {
			var st = ChannelModel.status_all();
			if (typeof(st) != "undefined") {
				var ret = {}
				_.each(st, (data, id) => {
					if (data.headend_instance == this.id) {
						ret[id] = data;
					}
				});
				return ret;
			}
			return {};
		}
	}
}
</script>